
import { IPushbackDetail } from "../../../models/configuration/pushback/IPushbackLoans";
import { Action, ActionType } from "../../actions";

interface PushbackDetailState {
  loading: boolean;
  error: string | null;
  data: IPushbackDetail | null;
}

const initialState = { loading: false, error: null, data: null };

const pushbackDetailReducer = (
  state: PushbackDetailState = initialState,
  action: Action
): PushbackDetailState => {
  switch (action.type) {
    // GET DATA
    case ActionType.GET_PUSHBACK_DETAIL:
      return { ...state, loading: true, error: null };
    case ActionType.GET_PUSHBACK_DETAIL_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ActionType.GET_PUSHBACK_DETAIL_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload };
    case ActionType.CONFIG_ID_CHANGED:
      return initialState;
    default:
      return state;
  }
};

export default pushbackDetailReducer;